import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractAutoGroundButtonComponent } from '../abstract-auto-ground-button';

@Component({
  selector: 'h3-split-view-auto-ground-button',
  templateUrl: './split-view-auto-ground-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplitViewAutoGroundButtonComponent extends AbstractAutoGroundButtonComponent {}
